import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { mediaQuery } from '@picsart/rc/helpers';
import { createUseStyles } from 'react-jss';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { Spacings } from '@picsart/design-system/foundation/spacings';

const useStyles = createUseStyles(
  () => ({
    title: {
      maxWidth: 572,
      lineHeight: LineHeights.l72,
      fontSize: FontSizes.s60,
      textAlign: 'left',
      margin: [Spacings.s0, Spacings.s0, Spacings.s24],

      [mediaQuery(1365)]: {
        maxWidth: 460,
      },

      [mediaQuery(1023)]: {
        maxWidth: 360,
        lineHeight: LineHeights.l36,
        fontSize: FontSizes.s30,
        margin: [Spacings.s0, 'auto', Spacings.s24],
        textAlign: 'center',
      },
    },
    actionHolder: {
      display: 'flex',
      flexWrap: 'wrap',

      [mediaQuery(1023)]: {
        justifyContent: 'center',
      },
    },
    description: {
      display: 'flex',
      margin: [Spacings.s0, Spacings.s0, Spacings.s24],

      [mediaQuery(1023)]: {
        margin: [Spacings.s0, 'auto', Spacings.s24],
        justifyContent: 'center',
      },

      '& p': {
        textAlign: 'left',
        lineHeight: LineHeights.l28,
        fontSize: FontSizes.s16,

        [mediaQuery(1023)]: {
          maxWidth: 360,
          textAlign: 'center',
          lineHeight: LineHeights.l32,
        },
      },
    },
    secondDescription: {
      margin: [Spacings.s32, 'auto', Spacings.s24],

      [mediaQuery(1023)]: {
        display: 'flex',
        justifyContent: 'center',
      },

      '& p': {
        textAlign: 'left',
        fontSize: FontSizes.s14,
        lineHeight: LineHeights.l20,

        [mediaQuery(1023)]: {
          maxWidth: 360,
          textAlign: 'center',
          fontSize: FontSizes.s12,
        },
      },
    },
    bulletListWrapper: {
      maxWidth: '100%',

      [mediaQuery(1023)]: {
        maxWidth: 680,
        margin: [Spacings.s0, 'auto'],
      },

      // [mediaQuery(766)]: {
      '@media screen and (max-width: 766px)': {
        maxWidth: 460,
      },
    },
    action: {
      padding: [Spacings.s16, Spacings.s32],
      fontWeight: FontWeights.medium,
      fontSize: FontSizes.s16,
    },
  }),
  {
    name: 'animated-content',
  },
);

export default useStyles;
